package org.solyton.solawi.bid.module.banking.data.bankaccount

enum class AccountType {
    CREDITOR,
    DEBTOR
}
